import React from "react";

const Up = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 4 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.51184 1.90137L1.93807 0.327599L0.364304 1.90137"
        stroke="currentColor"
        strokeWidth="0.629507"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Up;
